module.exports = __webpack_public_path__ + "img/iconos2.ff565c08.png";